module.exports = __webpack_public_path__ + "static/5-5e5f60af648390bad67ed1e307877633.jpg";